import { Breadcrumb, Button, Card, Popconfirm, Row } from 'antd'
import ContractForm from '../../../../../components/People/Member/Contract/ContractForm'
import React, { Component, Fragment } from 'react'
import style from './style.css'

class AddContract extends Component {
  render() {
    const titles = {
      new: 'Create new Employee Contract',
      update: 'Update Employee Contract',
    }
    const descriptions = {
      new: 'You can add new Employee Contract by following the steps below.',
      update: 'You need to follow the steps below to update Employee Contract.',
    }
    const {
      updateContract,
      updateContractRollover,
      updateContractMedicalOptions,
      member,
      submit,
      update,
      contract,
      type,
      submitting,
      employee,
      memberFetching,
      contractKey,
      id,
      contractRef,
    } = this.props

    const submitButton = {
      new: (
        <Fragment>
          <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
            <Button loading={submitting} type="primary">
              Submit
            </Button>
          </Popconfirm>
        </Fragment>
      ),
      update: (
        <Popconfirm title="Sure to Update?" onConfirm={() => update()}>
          <Button loading={submitting} type="primary">
            Update
          </Button>
        </Popconfirm>
      ),
    }
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Sales</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team">Team List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${id}/`}>{member.fn}</Breadcrumb.Item>
              <Breadcrumb.Item href={type === 'update' && `#/people/member/${id}/contracts/${contractKey}/view`}>
                {type === 'update' ? contract.code : titles[type]}
              </Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>{titles[type]}</h2>
            <p className={style.paragraph}>{descriptions[type]}</p>
          </Row>
        </Card>
        <Card loading={memberFetching} className={style.contentCard}>
          <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
            <ContractForm
              ref={contractRef}
              {...{
                updateContract,
                updateContractRollover,
                updateContractMedicalOptions,
                employee,
                contract,
                type,
              }}
            />
          </div>
          <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
            {submitButton[type]}
          </div>
        </Card>
      </Fragment>
    )
  }
}

export default AddContract
